<template>
    <section></section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {InvitationReferencingSlice} from '@prismicio-types';

    defineProps(getSliceComponentProps<InvitationReferencingSlice>(['slice', 'index', 'slices', 'context']));
</script>
